fragment BookingFragment on Booking {
    id
    status
    rescheduleUrl
    activity {
        id
        name
    }
    meeting {
        id
        meetingType
    }
    formSubmission {
        primaryEntity {
            ... on Account {
                id
                name
                avatarUrl
                initials
                htmlUrl
            }
            ... on Contact {
                id
                name
                avatarUrl
                initials
                htmlUrl
            }
        }
        id
        submissionTime
        submissionUrl
        formVersion {
            id
            form {
                id
                name
                htmlUrlPath
            }
        }
        fields {
            edges {
                node {
                    id
                    label
                    isRequired
                }
                fieldValue {
                    ... on FormFieldSubmissionValueMultiple {
                        values
                    }

                    ... on FormFieldSubmissionValueSingle {
                        value
                    }
                }
            }
        }
    }
    startTime
    createdTime
    hostUser {
        id
        name
        timezone
    }
}
